export default "__VITE_ASSET__DZi1w0FO__"